import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import About4 from "./../Elements/About4";
import AboutSummary from "./../Elements/AboutSummary";
import OurServices from "../Elements/OurServices";

var bnrimg = require("./../../images/home/1.png");

class About extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Banner
            title="Providing timely services that simplify everyday life and support growing communities."
            pagename="About Us"
            bgimage={bnrimg}
          />
          <About4 />
          <OurServices />
          <AboutSummary />
        </div>

        <Footer />
      </>
    );
  }
}

export default About;
